import { render, staticRenderFns } from "./table-mock.vue?vue&type=template&id=cdeef346&"
import script from "./table-mock.ts?vue&type=script&lang=ts&"
export * from "./table-mock.ts?vue&type=script&lang=ts&"
import style0 from "./table-mock.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports